/*
 * File: product.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on July 28, 2022 at 10:40 AM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: July 28, 2022 at 10:41 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { formatDateString } from '../../utilities/dateTime';


/**
 * Utilities
 */

// Format offer validity date
export const formatOfferDate = () => {
	const now = new Date();
	now.setFullYear(now.getFullYear() + 10);
	return formatDateString(now, 'YYYY-MM-DD');
};
